import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import Header from '@/components/HeaderPanel.vue';
import Sidebar from '@/components/Sidebar.vue';
import { ShieldAlertIcon, InfoIcon, HomeIcon, ArrowLeftIcon } from 'lucide-vue-next';
export default defineComponent({
    name: 'AccessDenied',
    components: {
        Header,
        Sidebar,
        ShieldAlertIcon,
        InfoIcon,
        HomeIcon,
        ArrowLeftIcon
    },
    setup() {
        const router = useRouter();
        const goToHome = () => {
            router.push('/');
        };
        const goBack = () => {
            router.go(-1);
        };
        return {
            goToHome,
            goBack
        };
    }
});
